/// <reference path='meevoMessengerSettings.module.ts' />
/// <reference path='../../../../typings/index.d.ts' />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    class MeevoMessengerSettingsController extends Meevo.Components.CommonClasses.CommonControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.BusinessInfoDataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.busy.BusyService',
            'meevo.plugins.meevoMessengerSettings.meevoMessengerSettingsService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            '$filter',
            '$q',
            '$translate'
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected meevoMessengerSettingsService: IMeevoMessengerSettingsService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $filter: angular.IFilterService,
            protected $q: angular.IQService,
            private $translate: angular.translate.ITranslateService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.INTEGRATION_TRANSWORLD).then(() => {
                this.busyService.stop();
                this.context = new MeevoMessengerSettingsContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$scope, this.$filter, this.$q, this.$translate, this.meevoMessengerSettingsService, this.contextParams, this.$rootScope);
                super.createContext();

                this.context.postUpdate = (model: Meevo.Model.IMeevoMessengerSettings) => {
                    const userAbleToGetNotifications = {};

                    userAbleToGetNotifications[model.classification.toLowerCase()] = _.contains(model.usersToNotify, this.identityService.current().userId);
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.MEEVO_MESSENGER_UPDATE_USER_TO_NOTIFY, userAbleToGetNotifications);
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TEXTEL_UPDATE_MODEL, model);
                    if (Model.Guard.isSomething(this.context.closeCallback))
                        this.context.closeCallback(model, true);
                }
            });
        }
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .controller('meevo.plugins.meevoMessengerSettings.MeevoMessengerSettingsController', MeevoMessengerSettingsController);
}
